import React, { useMemo } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector } from 'react-redux';
import { Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import NoResultsMessage from '../../../../../components/NoResultsMessage';
import LoadingSpinner from '../../../../../components/Spinner';
import emptyFolder from '../../../../../empty-folder.png';
import { globalRequirementTemplateBuilder } from '../../../../../redux/reducer';

import TemplateRow from './TemplateRow';

const TemplateListPanel = ({ templates, pageInfo, fetchNext }) => {
  const isLoading = useSelector(globalRequirementTemplateBuilder.selectTemplatesLoading);

  const templateRows = useMemo(() => (templates || []).map(template => (
    <TemplateRow key={template.id} template={template} />
  )), [templates]);

  if (isLoading) {
    return (
      <Flex alignItems="center" justifyContent="center">
        <LoadingSpinner leftMargin="auto" />
      </Flex>
    );
  }

  return (
    <InfiniteScroll
      dataLength={templates.length}
      hasMore={pageInfo.currentPage < pageInfo.lastPage}
      height="66vh"
      loader={<LoadingSpinner isInline />}
      next={fetchNext}
      scrollableTarget="template-tab-content"
      scrollThreshold={0.8}
    >
      {templates.length && !isLoading
        ? templateRows
        : (
          <NoResultsMessage
            altTag="No templates to show"
            image={emptyFolder}
            message="No templates yet."
          />
        )}
    </InfiniteScroll>
  );
};

TemplateListPanel.propTypes = {
  templates: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    template: PropTypes.shape({})
  })),
  pageInfo: { hasMore: PropTypes.bool },
  fetchNext: PropTypes.func
};

export default TemplateListPanel;
